import React, { useState } from 'react';
import { GridWrapper } from 'components/Ui/styled';
import { getDataGridHeading } from 'utils/commonUtils';
import MyPreferencesDialog from '../myPreferences/MyPreferencesDialog';
import { Grid } from '@mui/material';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const MyPreferencesTab = (props) => {
  const { profilePreferences, setProfilePreferences } = props;
  const [myPreferencesDialog, setMyPreferencesDialog] = useState(false);
  const canAccessUserPreferences = usePermissionCustomHook(
    'CAN_ACCESS_USER_PREFERENCES'
  );

  const profilePreferencesInfo = [
    {
      label: 'Enabled Email Notifications',
      value: profilePreferences?.emailNotificationsEnabled ? 'Yes' : 'No',
    },
    {
      label: 'Enabled Tutor Email Notifications',
      value: profilePreferences?.tutorEmailNotificationsEnabled ? 'Yes' : 'No',
    },
  ];

  const handleMyPreferences = async () => {
    setMyPreferencesDialog(true);
  };

  return (
    <>
      {getDataGridHeading(
        'Preferences',
        canAccessUserPreferences && 'My Preferences',
        canAccessUserPreferences ? handleMyPreferences : undefined
      )}
      <GridWrapper container spacing={2} style={{ padding: '0px 24px' }}>
        <Grid item xs={12} sm={4}>
          {canAccessUserPreferences &&
            profilePreferencesInfo.map((field) => (
              <MDBox key={field.label}>
                <MDTypography
                  variant="button"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {field.label}: &nbsp;
                </MDTypography>
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color="text"
                >
                  &nbsp;{field.value || '-'}
                </MDTypography>
              </MDBox>
            ))}
        </Grid>
      </GridWrapper>
      <MyPreferencesDialog
        myPreferencesDialog={myPreferencesDialog}
        setMyPreferencesDialog={setMyPreferencesDialog}
        profilePreferences={profilePreferences}
        setProfilePreferences={setProfilePreferences}
      />
    </>
  );
};

export default MyPreferencesTab;
